import React from 'react';
import { B12Chatbot } from './b12-chatbot';
import { SiemensChatBot } from './siemens-chat-bot';

export const Chatbot: React.FC = () => {
  if (process.env.GATSBY_CHATBOT === 'b12') {
    return <B12Chatbot />;
  }
  return <SiemensChatBot />;
};
